export const groups = [
  { label: "Inicio", to: "/", icon: "inicio" },
  {
    label: "CRM",
    items: [
      ["Prospectos", "/crm/prospectos", "prospectos"],
      ["Oportunidades", "/crm/oportunidades", "oportunidades"],
      ["Seguimientos", "/crm/seguimientos", "seguimientos"],
    ],
  },
  {
    label: "Ventas",
    items: [
      ["Cotizaciones", "/ventas/cotizaciones", "cotizaciones"],
      ["Pedidos", "/ventas/pedidos", "pedidos"],
      ["Remisiones", "/ventas/remisiones", "remisiones"],
      ["Facturas y notas", "/ventas/facturas", "facturas"],
      ["Notas de crédito", "/ventas/credito", "credito"],
    ],
  },
  {
    label: "Cobranza",
    items: [
      ["Cuentas por cobrar", "/cobranza", "cartera"],
      ["Cobros", "/cobranza/cobros", "cobros"],
      ["Estado de cuenta", "/estado-cuenta", "cartera"],
    ],
  },
  {
    label: "Finanzas",
    items: [
      ["Ingresos", "/finanzas/ingresos", "ingresos"],
      ["Egresos", "/finanzas/egresos", "egresos"],
      ["Gastos", "/finanzas/gastos", "gastos"],
      ["Transferencias bancarias", "/finanzas/transferencias", "transferencias"],
    ],
  },
  {
    label: "Reportes",
    items: [
      ["Bancos", "/reportes/bancos", "bancos"],
      ["Ventas", "/reportes/ventas", "reporte-ventas"],
      ["Antigüedad de saldos", "/reportes/antiguedad", "cartera"],
      ["Seguimiento comercial", "/reportes/seguimiento", "seguimientos"],
    ],
  },
  {
    label: "Catálogos",
    items: [
      ["Clientes", "/catalogos/clientes", "clientes"],
      ["Productos", "/catalogos/productos", "productos"],
      ["Unidades de medida", "/catalogos/unidades", "unidades"],
    ],
  },
];
export const visibleGroups = (modules) =>
  groups
    .map((g) =>
      g.items ? { ...g, items: g.items.filter((i) => modules?.[i[2]]) } : g
    )
    .filter((g) => !g.items || g.items.length);
